/* tslint:disable */
const colors = {
  /* Rainbow */
  Teal100: "#064650",
  Teal80: "#386b73",
  Teal60: "#6a9096",
  Teal12: "#e1e8ea",
  Teal04: "#f6f8f9",
  Red100: "#f0655d",
  Red80: "#f1746d",
  Red60: "#fac8c5",
  Red12: "#fdeceb",
  Red04: "#fff9f9",
  Clay100: "#4d4238",
  Clay80: "#665e56",
  Clay20: "#dad0ca",
  Clay12: "#e9e8e7",
  Clay4: "#f8f8f7",
  Green100: "#0b4b40",
  Green80: "#3c6f66",
  Green12: "#e1e9e8",
  Green04: "#f5f8f8",
  Turquoise100: "#bbf5ed",
  Turquoise60: "#d6f9f4",
  OffWhite: "#f9f9f9",

  EvergreenLight: "#0DC3A1",
  EvergreenLighter: "#86E3D0",

  /* Graph Colors */
  KindurGraphDarkGreen: "#02A62C",

  /* Grayscale */
  Black: "#000000",
  Gray1: "#333333",
  Gray2: "#6B6B6B",
  Gray3: "#ABABAB",
  Gray4: "#CCCCCC",
  Gray5: "#DCDCDC",
  Gray6: "#EEEEEE",
  Gray7: "#FAFAFA",
  White: "#FFFFFF",
  Transparent: {
    Black80: "rgba(0,0,0,0.8)",
    Black58: "rgba(0,0,0,0.58)",
    Black33: "rgba(0,0,0,0.33)",
    Black20: "rgba(0,0,0,0.2)",
    Black14: "rgba(0,0,0,0.14)",
    Black07: "rgba(0,0,0,0.07)",
    White20: "rgba(255,255,255,0.20)",
    White42: "rgba(255,255,255,0.42)",
    White67: "rgba(255,255,255,0.67)",
    White80: "rgba(255,255,255,0.80)",
    White86: "rgba(255,255,255,0.86)",
    White93: "rgba(255,255,255,0.93)",
    White98: "rgba(255,255,255,0.98)",
    EverGreenLighter25: "rgba(128,216,198,0.25)",
  },

  /* Silvur colors */
  DarkPurple: "#5133b4",
  DarkGreen: "#0abfab",
  LightGreen: "#e1fff5",
  Gray: "#6e6e7d",
  LightGray: "#f2f2f7",
  MediumGray: "#9D9DA8",
};

export default colors;
/* tslint:enable */
